export default __webpack_public_path__ + "static/avatar_5-99a3286efa1e176ba8e6c07e3416998d.svg";